import client from '../../../helpers/client';
import cognito from '../../../helpers/cognito';

export const getListBountyByDao = (params) => {
  return async () => {
    const { daoId, chainId, page, limit } = params;
    const queryParams = new URLSearchParams({
      daoId,
      chainId,
      page,
      limit
    }).toString();
    
    return client
      .api(`/bounty/get-all-bounties?${queryParams}`, 'get', {
        headers: await cognito.getHeaderAuthorization()
      })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const updateBounty = (bountyId, data) => {
  return async () => {
    return client
      .api(`/bounty/update-bounty/${bountyId}`, 'put', data,
        { headers: await cognito.getHeaderAuthorization() }
      )
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const getDetailBounty = (bountyId, combineWiths = ['bountyjudge']) => {
  return async () => {
    const queryParams = new URLSearchParams({
      id: bountyId,
      combineWiths: combineWiths
    }).toString();

    return client
      .api(`/bounty/get-bounty/${bountyId}?${queryParams}`, 'get', {
        headers: await cognito.getHeaderAuthorization()
      })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const createBounty = (data) => {
  return async () => {
    return client
      .api(`/bounty/create`, 'post', data,
        { headers: await cognito.getHeaderAuthorization() }
      )
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};
